export const activeColorObj = {
	0: '#748AFE',
	normal: '#29C287',
	offline: '#AFB4CC',
	alarm: '#FF9419',
	fault: '#E5662E',
}
